module.exports = __webpack_public_path__ + "media/src/pages/GuidedOnboarding/images/filePencilCheck-403aee1f159fda76f157045cdf657cb4.png";